import React from "react";
import { FormField, ErrorMessage, InfoIcon } from "@vwfs-bronson/bronson-react";
import { getIn } from "formik/dist/index";
import MaskedInput from 'react-text-mask';

export function IbanField({
  field: { onChange, onBlur, name, ...field },
  form: { setFieldValue, errors, touched },
  normalizeOnChange,
  normalize,
  label,
  tooltip,
  notion,
  ...props
}) {
  const ibanMask = [
    /[A-Z]/i,
    /[A-Z]/i,
    /[\d]/i,
    /[\d]/i,
    ' ',
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    ' ',
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    ' ',
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    ' ',
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    /[A-Z\d]/i,
    ' ',
    /[A-Z\d]/i,
    /[A-Z\d]/i,
  ];

  const error = getIn(touched, name) && getIn(errors, name);

  const normalizeIban = value => {
    return value.split(' ').join('')
  }

  const id = props.id || name;

  const handleChange =  ({ target: { name, value } }) => {
    return onChange({
      target: { name, value: normalizeIban(value) },
    });
  }

  const handleBlur = ({ target: { name, value } }) => {
    setFieldValue(name, normalizeIban(value), false);
    return onBlur({ target: { name } });
  };
  
  return (
    <FormField
      type={field.type || "other"}
      labelText={label}
      id={id}
      infoIcon={tooltip && <InfoIcon icon="semantic-info">{tooltip}</InfoIcon>}
      notion={notion}
      errorMessage={error ? <ErrorMessage id={id}>{error}</ErrorMessage> : null}
    >
      <MaskedInput
        {...props}
        {...field}
        className={`c-input__input ${error ? 'is-error': ''}`}
        name={name}
        guide={false}
        mask={ibanMask}
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!error}
      />
    </FormField>
  );
}
